import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { FloatingWhatsApp } from './FloatingWhatsApp';
import { ScrollToTop } from './ScrollToTop';
export function Layout() {
  return <div className="min-h-screen bg-brand-primary text-brand-cream font-sans selection:bg-brand-gold selection:text-brand-primary" data-id="element-201">
      <ScrollToTop data-id="element-202" />
      <Navbar data-id="element-203" />
      <main data-id="element-204">
        <Outlet data-id="element-205" />
      </main>
      <Footer data-id="element-206" />
      <FloatingWhatsApp data-id="element-207" />
    </div>;
}